/**
 * Constantes para o componente Result List
 */

import { AVATAR_FIELDS, NAME_FIELDS } from '../shared/avatar/avatar.constants';

/**
 * Campos que indicam tipo/categoria
 */
export const TYPE_FIELDS = ['tipo', 'type', 'categoria', 'category', 'tipo_entrada', 'entry_type'];

/**
 * Campos que indicam valor monetário
 */
export const VALUE_FIELDS = ['valor', 'value', 'amount', 'total', 'quantia', 'preco', 'price', 'limite', 'saldo', 'gasto', 'gastos'];

/**
 * Campos que devem ser capitalizados (primeira letra maiúscula)
 */
export const CAPITALIZE_FIELDS = ['bandeira', 'brand', 'marca', 'status', 'situacao', 'situação'];

/**
 * Campos que indicam transação/pagamento
 */
export const TRANSACTION_FIELDS = ['transacao', 'transação', 'transaction', 'forma_pagamento', 'payment_method', 'metodo'];

/**
 * Campos que indicam data
 */
export const DATE_FIELDS = ['data', 'date', 'data_transacao', 'data_entrada', 'created_at', 'updated_at', 'nascimento', 'birthday'];

/**
 * Campos que indicam idade
 */
export const AGE_FIELDS = ['nova_idade', 'idade', 'age', 'new_age'];

/**
 * Campos que devem ser ocultados
 */
export const HIDDEN_FIELDS = ['genero', 'gender', 'sexo', 'ativo', 'activated', 'active'];

/**
 * Classes CSS para badges de tipo
 */
export const TYPE_BADGE_CLASSES: { [key: string]: string } = {
    'DÍZIMO': 'bg-emerald-100 text-emerald-700',
    'DIZIMO': 'bg-emerald-100 text-emerald-700',
    'OFERTA': 'bg-blue-100 text-blue-700',
    'DESIGNADA': 'bg-purple-100 text-purple-700',
    'SAÍDA': 'bg-red-100 text-red-700',
    'SAIDA': 'bg-red-100 text-red-700',
    'CAMPANHA': 'bg-amber-100 text-amber-700',
    'VOTO': 'bg-indigo-100 text-indigo-700',
    'DEFAULT': 'bg-gray-100 text-gray-600'
};

/**
 * Larguras de coluna por tipo
 */
export const COLUMN_WIDTHS: { [key: string]: string } = {
    'type': 'w-[100px] text-center',
    'value': 'w-[120px]',
    'transaction': 'w-[100px] text-center',
    'date': 'w-[130px]',
    'age': 'w-[80px] text-center',
    'default': 'w-[100px]'
};

/**
 * Obtém o tipo de coluna
 */
export function getColumnType(key: string): 'type' | 'value' | 'transaction' | 'date' | 'age' | 'avatar' | 'name' | 'capitalize' | 'default' {
    const lowerKey = key.toLowerCase();

    if (AVATAR_FIELDS.includes(lowerKey)) return 'avatar';
    if (NAME_FIELDS.includes(lowerKey)) return 'name';
    if (TYPE_FIELDS.includes(lowerKey)) return 'type';
    if (VALUE_FIELDS.includes(lowerKey)) return 'value';
    if (TRANSACTION_FIELDS.includes(lowerKey)) return 'transaction';
    if (DATE_FIELDS.includes(lowerKey)) return 'date';
    if (AGE_FIELDS.includes(lowerKey)) return 'age';
    if (CAPITALIZE_FIELDS.includes(lowerKey)) return 'capitalize';

    return 'default';
}

/**
 * Verifica se a coluna deve ser ocultada
 */
export function shouldHideColumn(key: string): boolean {
    return HIDDEN_FIELDS.includes(key.toLowerCase());
}

/**
 * Obtém a classe CSS de largura da coluna
 */
export function getColumnWidthClass(key: string): string {
    const type = getColumnType(key);
    return COLUMN_WIDTHS[type] || COLUMN_WIDTHS['default'];
}

/**
 * Obtém a classe CSS para badge de tipo
 */
export function getTypeBadgeClass(type: string): string {
    if (!type) return TYPE_BADGE_CLASSES['DEFAULT'];
    return TYPE_BADGE_CLASSES[type.toUpperCase()] || TYPE_BADGE_CLASSES['DEFAULT'];
}
